export default __webpack_public_path__ + "static/media/AB1_Investor_Slide_mobile.556a9dcd.png";